import { Pipe, PipeTransform } from "@angular/core";
import { config } from "@config";
import { TRADABLES_TYPE } from "@helpers/constants";
import { Tradable } from "@models/interfaces/tradable";
import { convertText } from "@helpers/functions";

export interface linkReplaceOption {
	toReplace: string;
	tradable?: Tradable;
	urlLeverageToken: string;
}

@Pipe({
	name: "tcLinkReplace",
	pure: false,
	standalone: false
})
export class TcLinkReplacePipe implements PipeTransform {
	public transform(text: string, option: linkReplaceOption): string {
		const { toReplace, tradable } = option;
		if (!tradable) {
			return text;
		}

		return text.replace(toReplace, this.replaceWithUrl(tradable, option.urlLeverageToken));
	}

	private replaceWithUrl(tradable: Tradable, urlLeverageToken: string): string {
		let baseUrl: string = config.baseUrl;
		switch (tradable.getCurrencyType()) {
			case TRADABLES_TYPE.LEVERAGED_TOKEN:
				return baseUrl.slice(0, -1) + urlLeverageToken; // API sends the url with extra "slash" so we need to remove one
			case TRADABLES_TYPE.STOCK:
				baseUrl += "prices/" + config.externalPaths["tradeTerms"]["stocks"];
				break;
			case TRADABLES_TYPE.ETF:
				baseUrl += "prices/" + config.externalPaths["tradeTerms"]["etfs"];
				break;
			case TRADABLES_TYPE.ETC:
				baseUrl += "prices/" + config.externalPaths["tradeTerms"]["etcs"];
				break;
			case TRADABLES_TYPE.SECURITY_TOKEN:
				baseUrl += "prices/" + config.externalPaths["tradeTerms"]["security"];
				break;
			default:
				baseUrl += config.externalPaths["tradeTerms"]["stocks"];
				break;
		}
		const tradableName: string = convertText(tradable.getName());
		const tradableSymbol: string = convertText(tradable.getSymbol(true));
		return baseUrl + tradableName + "-" + tradableSymbol + "#downloads";
	}
}
